import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index'
import Login from '../views/Login.vue'

import MainPage from '../components/Main/MainPage.vue'
import BaseDatos from '../components/BaseDatos/BaseDatos.vue'
import Brigadas from '../components/Brigadas/Brigadas.vue'
import Usuarios from '../components/Usuarios/Usuarios.vue'
import Reportes from '../components/Reportes/Reportes.vue'
import InfoQR from '../components/InfoQR/InfoQR.vue'
import Quirofanos from '../components/Quirofanos/Quirofanos.vue'
import Conciliacion from '../components/Conciliacion/Conciliacion.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/', component: MainPage,
    children: [
      { path: 'Home', component: Home, name: 'Home', meta: { Administrador: true, Controller: true, Coordinador: true } },
      { path: 'BaseDatos', component: BaseDatos, name: 'BaseDatos', meta: { Administrador: true, Controller: true, Coordinador: true } },
      { path: 'Brigadas', component: Brigadas, name: 'Brigadas', meta: { Administrador: true, Controller: true, Coordinador: true } },
      { path: 'Usuarios', component: Usuarios, name: 'Usuarios', meta: { Administrador: true, Controller: false, Coordinador: false } },
      { path: 'Reportes', component: Reportes, name: 'Reportes', meta: { Administrador: true, Controller: true, Coordinador: true } },
      { path: 'Quirofanos', component: Quirofanos, name: 'Quirofanos', meta: { Administrador: true, Controller: false, Coordinador: false } },
      { path: 'Conciliacion', component: Conciliacion, name: 'Conciliacion', meta: { Administrador: true, Controller: false, Coordinador: false } },
    ],
  },
  { path: '/Login', name: 'Login', component: Login, meta: { libre: true } },
  { path: '/InfoQR', name: 'InfoQR', component: InfoQR, meta: { libre: true } },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.libre)) {
    next()
  } else if (store.state.usuario && store.state.usuario.rol == 'Administrador') {
    if (to.matched.some(record => record.meta.Administrador)) {
      next()
    }
  } else if (store.state.usuario && store.state.usuario.rol == 'Controller') {
    if (to.matched.some(record => record.meta.Controller)) {
      next()
    }
  } else if (store.state.usuario && store.state.usuario.rol == 'Coordinador') {
    if (to.matched.some(record => record.meta.Coordinador)) {
      next()
    }
  }
  else {
    next({
      name: 'Login'
    })
  }
})

export default router
